// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"UAFvC9k3VuuhSISeSkS-2A==","closeIcon":"_4EYJ+jJCa9bWnrheO+O8rg==","item":"+JQMYlXydCAYQKVYb-BZ4g=="};